import React from "react";
import { useState, useEffect } from "react";
import {
    FaHeart,
    FaComment,
} from "react-icons/fa";
import { FaGift } from "react-icons/fa6";
import { FaCoins, FaBitcoin, FaDollarSign, FaTrophy, FaGem, FaChartLine, FaRocket, FaCrown, FaBolt, FaStar } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import ProfileService from "../../../services/Profile";



export default function NewPackages() {
    const navigate = useNavigate();
    const [newPackages, setNewPackages] = useState([]);

    const getPackageIcon = (pkg) => {
        const name = pkg?.name?.toLowerCase() || '';

        if (name.includes('gold')
            //  || name.includes('') || name.includes('')
        ) {
            return <FaCrown className="text-3xl text-gray-600" />;
        }
        if (name.includes('silver')
            //  || name.includes('') || name.includes('')
        ) {
            return <FaRocket className="text-3xl text-gray-600" />;
        }
        if (name.includes('bronze')
            //  || name.includes('') || name.includes('')
        ) {
            return <FaGift className="text-3xl text-gray-600" />;
        }

        return <FaStar className="text-3xl text-gray-600" />;
    };


    useEffect(() => {
        const getAllPackages = async () => {
            const params = { isSpecial: true };
            try {
                const res = await ProfileService.getAllPackages(params);
                setNewPackages(res?.data?.data)
                console.log("specialss", res?.data?.data)
            } catch (err) {
                console.error(err)
            }
        }

        getAllPackages();
    }, []);

    const [isLiked, setIsLiked] = useState({});
    const handleLike = (pkgId) => {
        setIsLiked((prev) => ({ ...prev, [pkgId]: !prev[pkgId] }));
        console.log(`Package with ID ${pkgId} liked: ${!isLiked[pkgId]}`);
    };

    return (
        <section id="new-packages" className="py-6">
            <div className="px-4 mb-4">
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-bold">Special Packages</h2>
                    <button className="text-sm text-primary font-medium">View All</button>
                </div>
                <p className="text-sm text-gray-500 mt-1">Best trading packages</p>
            </div>

            <div className="flex gap-4 overflow-x-auto px-4 pb-2">
                {newPackages.map((pkg) => (
                    <div
                        key={pkg?._id}
                        onClick={() => navigate(`/signal/package/${pkg?._id}`)}
                        className={`flex-shrink-0 w-64 border border-gray-200 rounded-2xl shadow-md p-4 flex flex-col justify-between cursor-pointer hover:shadow-lg transition-shadow duration-300`}
                    >

                        {/* <div className="flex-shrink-0 w-64"> */}
                        {/* <div className="uniform-package-card h-72 w-64 rounded-2xl flex flex-col justify-between p-4 shadow-lg relative overflow-hidden"> */}
                        <div>
                            <div className="flex justify-between items-start mb-2">
                                {pkg?.packageIcon === "coins" ? <FaCoins className="text-2xl text-gray-700" />
                                    :
                                    pkg?.packageIcon === "bitcoin" ? <FaBitcoin className="text-2xl text-gray-700" />
                                        :
                                        pkg?.packageIcon === "dollar" ? <FaDollarSign className="text-2xl text-gray-700" />
                                            :
                                            pkg?.packageIcon === "crown" ? <FaCrown className="text-2xl text-gray-700" />
                                                :
                                                pkg?.packageIcon === "rocket" ? <FaRocket className="text-2xl text-gray-700" />
                                                    :
                                                    pkg?.packageIcon === "trophy" ? <FaTrophy className="text-2xl text-gray-700" />
                                                        :
                                                        pkg?.packageIcon === "gem" ? <FaGem className="text-2xl text-gray-700" />
                                                            :
                                                            pkg?.packageIcon === "star" ? <FaStar className="text-2xl text-gray-700" />
                                                                : null
                                }
                                <span className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded-full">{pkg?.packageBadge}</span>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900">{pkg?.name}</h3>
                            <p className="text-gray-600 text-sm">{pkg?.description}</p>
                            <div className="flex items-center space-x-3 mt-2">
                                <div className="flex items-center space-x-1">
                                    <FaHeart className="text-gray-400 text-sm" />
                                    <span className="text-gray-600 text-sm">{pkg?.likes}</span>
                                </div>
                                <div className="flex items-center space-x-1">
                                    <FaComment className="text-gray-400 text-sm" />
                                    <span className="text-gray-600 text-sm">{pkg?.commentCount}</span>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-2 text-gray-700">
                            <div className="flex justify-between items-center text-sm">
                                <span className="text-gray-600">Signals/Month</span>
                                <span className="font-semibold">-</span>
                            </div>
                            <div className="flex justify-between items-center text-sm">
                                <span className="text-gray-600">Monthly Profit</span>
                                <span className="font-semibold text-green-600">0%</span>
                            </div>
                            <div className="flex justify-between items-center text-xs">
                                <span className="text-gray-500">vs Last Month</span>
                                <span className="font-semibold text-green-600">0%</span>
                            </div>
                        </div>

                        <div className="border-t border-gray-300 pt-3">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <img className="w-8 h-8 rounded-full border-2 border-gray-300"
                                        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
                                        alt="Ahmad Rezaei" />
                                    <div>
                                        <p className="font-medium text-sm text-gray-900">Ahmad Rezaei</p>
                                        <p className="text-xs text-gray-600">Senior Analyst</p>
                                    </div>
                                </div>
                                <span className="text-gray-900 font-bold text-lg">{pkg?.price}</span>
                            </div>
                        </div>
                        {/* </div> */}
                        {/* </div> */}
                        {/* <div>
                            <div className="flex justify-between items-start mb-3">
                                <div className="flex items-center gap-2">
                                    {getPackageIcon(pkg)}
                                    <span className={`text-gray-600 bg-gray-200 text-xs px-2 py-1 rounded-full font-medium`}>
                                        {pkg?.label}
                                    </span>
                                </div>
                                <span className={` ${pkg?.status === "pending" ? "bg-gray-200 text-gray-700" : pkg?.status === "confirmed" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"} text-xs px-2 py-1 rounded-full`}>
                                    {pkg?.status}
                                </span>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900">{pkg?.name}</h3>
                            <p className="text-gray-600 text-sm">{pkg?.description}</p>
                            <div className="flex items-center space-x-3 mt-2">
                                <div className="flex items-center space-x-1">
                                    <FaHeart
                                        onClick={(e) => { e.stopPropagation(); handleLike(pkg?._id); }}
                                        className={`text-gray-400 text-sm cursor-pointer hover:text-red-500 transition-colors ${isLiked[pkg?._id] ? "text-red-500" : ""}`} />
                                    <span className="text-gray-600 text-sm">{Array.isArray(pkg?.likes) ? pkg?.likes?.length : pkg?.likes || 0}</span>
                                </div>
                                <div className="flex items-center space-x-1">
                                    <FaComment className="text-gray-400 text-sm" />
                                    <span className="text-gray-600 text-sm">{pkg?.comments || 0}</span>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-2 text-gray-700 mt-2">
                            <div className="flex text-start justify-between w-full gap-2 text-sm">
                                <span className="text-gray-600">days remaining</span>
                                <span className="font-semibold">{pkg?.duration?.days}</span>
                            </div>
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Monthly Profit</span>
                                <span className="font-semibold text-green-600">
                                    {pkg?.stats?.profit}
                                </span>
                            </div>
                            <div className="flex justify-between text-xs">
                                <span className="text-gray-500">vs Last Month</span>
                                <span className="font-semibold text-green-600">
                                    {pkg?.stats?.change}
                                </span>
                            </div>
                        </div>

                        <div className="border-t border-gray-300 pt-3 mt-3">
                            <div className="flex items-center justify-between">
                                <span className="text-xs text-gray-500">
                                    {pkg?.duration?.days ? `${pkg?.duration?.days} روز` : 'نامحدود'}
                                </span>
                                <span className="text-gray-900 font-bold text-lg block">
                                    {pkg?.price === 0 ? 'رایگان' : `${pkg?.price?.toLocaleString()} تومان`}
                                </span>
                            </div>
                        </div> */}
                    </div>
                ))}
            </div>
        </section>
    );
}
